// extracted by css-extract-rspack-plugin
export default {"container":"QuestionBody-module__container___pMM2U"};